<dff-side [observable]="kvittering$">
  @if (kvittering$ | async; as kvittering) {
    <dff-side-titel>Kvittering</dff-side-titel>
    <dff-side-tekst titel="Bemærk" [tekst]="sideTekst"></dff-side-tekst>
    @if (erMailSendt) {
      <dff-info type="success">
        Du vil i løbet af få minutter modtage en kvittering på e-mail: {{ formGroup.get("mailadresse").value }}
      </dff-info>
    }
    @if (!erMailSendt) {
      <form [formGroup]="formGroup">
        <panel>
          <h5>Angiv den mailadresse kvitteringen skal sendes til</h5>
          <div>
            <mat-form-field>
              <input id="mailadresse" matInput placeholder="Mailadresse" formControlName="mailadresse" />
              @if (formGroup.controls.mailadresse.hasError('email') && !formGroup.controls.mailadresse.hasError('required')) {
                <mat-error
                  >
                  Indtast en gyldig mailadresse.
                </mat-error>
              }
              @if (formGroup.controls.mailadresse.hasError('required')) {
                <mat-error>
                  Udfyld venligst feltet.
                </mat-error>
              }
            </mat-form-field>
          </div>
          <dff-button-panel align="left">
            <dff-spinner-button [spinning]="erSpinnerSynlig" (click)="opretKvitteringsmail()">Send kvittering</dff-spinner-button>
          </dff-button-panel>
        </panel>
        <br />
      </form>
    }
    <panel>
      <dff-kvittering [kvittering]="kvittering"></dff-kvittering>
    </panel>
  }
</dff-side>
